// VERSION: 1.0.3
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { ProductFilter } from '../../../shared/interfaces/product-filter';
import { isPlatformBrowser } from '@angular/common';
import { DirectionService } from '../../../shared/services/direction.service';
import { StoreService } from '@app/shared/services/store.service';

@Component({
    selector: 'app-widget-filters',
    templateUrl: './widget-filters.component.html',
    styleUrls: ['./widget-filters.component.scss']
})
export class WidgetFiltersComponent {
    @Input() filters: ProductFilter[] = [];
    @Input() offcanvas: 'always'|'mobile' = 'mobile';

    isPlatformBrowser = isPlatformBrowser(this.platformId);
    rightToLeft = true;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private direction: DirectionService,
        public store: StoreService
    ) {
        this.rightToLeft = this.direction.isLTR();
    }

    // Updated to handle null/undefined and use safe string conversion
    getNameUrl(v: string | null | undefined): string {
        if (!v) {
            return '';
        }
        // Using regex with 'g' flag for global replacement as a robust alternative to replaceAll
        return v.toString().replace(/ /g, '_');
    }
}